import { computed, toValue } from "vue";
import { useModalStore } from "./private/useModalStore.mjs";
export function useMagicModal(id) {
  const { modalStore, addInstance, removeInstance } = useModalStore();
  const isActive = computed(() => modalStore.value.includes(toValue(id)));
  function open() {
    addInstance(toValue(id));
  }
  function close() {
    removeInstance(toValue(id));
  }
  return {
    isActive,
    open,
    close
  };
}
